// German for TodayPage. English text is the key; a missing entry falls back to English.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Sunday': 'Sonntag', 'Monday': 'Montag', 'Tuesday': 'Dienstag', 'Wednesday': 'Mittwoch',
  'Thursday': 'Donnerstag', 'Friday': 'Freitag', 'Saturday': 'Samstag',

  'Log a touchpoint': 'Kontakt erfassen',
  'Review {n} →': 'Prüfung {n} →',
  'not collected': 'nicht erhoben',
  'unheld proposals': 'nicht übernommene Vorschläge',
  'nothing waiting': 'nichts wartend',

  // the UNHELD cell's detail line — one phrase per proposal kind, singular and plural
  '{n} fact': '{n} Sachverhalt', '{n} facts': '{n} Sachverhalte',
  '{n} affiliation': '{n} Zugehörigkeit', '{n} affiliations': '{n} Zugehörigkeiten',
  '{n} touchpoint': '{n} Kontakt', '{n} touchpoints': '{n} Kontakte',
  '{n} commitment': '{n} Zusage', '{n} commitments': '{n} Zusagen',
  '{n} persona': '{n} Persona', '{n} personas': '{n} Personas',
  '{n} draft': '{n} Entwurf', '{n} drafts': '{n} Entwürfe',
  '{n} candidate': '{n} Kandidat', '{n} candidates': '{n} Kandidaten',
  '{n} signal action': '{n} Signalhandlung', '{n} signal actions': '{n} Signalhandlungen',
  '{n} organisation': '{n} Organisation', '{n} organisations': '{n} Organisationen',
  '{n} person': '{n} Person', '{n} people': '{n} Personen',
  '{n} {kind}': '{n} {kind}',
  'Unheld': 'Nicht übernommen',
  'Signals': 'Signale',
  'no monitor runs yet · milestone M5': 'noch kein Monitor gelaufen · Meilenstein M5',
  'new signals': 'neue Signale',
  'Ball': 'Ball',
  'with us': 'bei uns',
  '{n} them': '{n} bei ihnen',
  '{who} overdue since {date}': '{who} überfällig seit {date}',
  'Stale': 'Überfällig',
  'deals': 'Geschäfte',
  'no deal is stale': 'kein Geschäft ist überfällig',
  'Cooling': 'Abkühlend',
  'people': 'Personen',
  'everyone is within cadence': 'alle innerhalb des Rhythmus',

  'Meetings today': 'Heutige Treffen',
  'No calendar feed is connected yet. This zone lists any interaction of kind meeting dated today; today has none on record.':
    'Es ist noch kein Kalender verbunden. Dieser Bereich zeigt alle Interaktionen der Art Treffen mit heutigem Datum; heute ist keines erfasst.',
  'with': 'mit',

  'Ball line': 'Ball-Liste',
  '{n} open': '{n} offen',
  'who owes whom · discharge needs evidence': 'wer wem etwas schuldet · Erledigung braucht einen Beleg',
  'No open commitments. A commitment is created from an interaction, or logged directly, and stays open until it is discharged with evidence or dropped with a reason.':
    'Keine offenen Zusagen. Eine Zusage entsteht aus einer Interaktion oder wird direkt erfasst und bleibt offen, bis sie mit Beleg erledigt oder mit Begründung verworfen wird.',
  'Owner': 'Wer schuldet',
  'Commitment': 'Zusage',
  'Counterpart': 'Gegenpartei',
  'Due': 'Fällig',
  'Source': 'Quelle',
  'not named': 'nicht benannt',
  'not set': 'nicht gesetzt',

  'Overnight': 'Über Nacht',
  '22:00 – 05:30': '22:00 – 05:30',
  'Agents →': 'Agenten →',
  'No night pass runs yet. From milestone M3 the inside agents triage mail, draft replies and run research overnight, and this zone reports what they read, proposed, committed and sent — always a click away from nothing sent.':
    'Es läuft noch kein Nachtdurchgang. Ab Meilenstein M3 sichten die internen Agenten über Nacht Post, entwerfen Antworten und recherchieren; dieser Bereich meldet, was sie gelesen, vorgeschlagen, zugesagt und versandt haben — versandt wird stets erst per Klick.',

  'tier cadence': 'Rhythmus nach Stufe',
  'People →': 'Personen →',
  'Nobody is past their cadence. A person cools when more days pass since the last logged interaction than their tier allows.':
    'Niemand ist über dem eigenen Rhythmus. Eine Person kühlt ab, wenn seit der letzten erfassten Interaktion mehr Tage vergangen sind, als die Stufe erlaubt.',

  // ── round 2 (§10): the SIGNALS rail cell, Next best actions, the Signals zone ──
  'no monitor exists and nothing has been raised': 'kein Monitor vorhanden, nichts gemeldet',

  'Next best actions': 'Nächstbeste Handlungen',
  'one per person · chosen by the highest-scoring reason': 'eine je Person · gewählt nach dem am höchsten bewerteten Grund',
  'People': 'Personen',
  'Nothing has been scored yet. The rules run at 05:00 and on every interaction, signal and commitment; each action names the commitment, the signal or the cadence that produced it, with its ref and its date.':
    'Es wurde noch nichts bewertet. Die Regeln laufen um 05:00 Uhr sowie bei jedem Kontakt, jedem Signal und jeder Zusage; jede Handlung nennt die Zusage, das Signal oder die Taktung, die sie erzeugt hat, mit Referenz und Datum.',
  'Everyone was scored and nobody needs a move: no open commitment with us, no signal in thirty days, and every cadence is being kept.':
    'Alle wurden bewertet und niemand braucht einen Schritt: keine offene Zusage bei uns, kein Signal seit dreissig Tagen, und jede Taktung wird eingehalten.',
  'no reason was recorded': 'kein Grund festgehalten',
  'written by {by}': 'geschrieben von {by}',
  'score': 'Bewertung',
  'Done': 'Erledigt',
  'Dismiss': 'Verwerfen',
  'Marked done.': 'Als erledigt vermerkt.',
  'Dismissed. It will not be proposed again for seven days.': 'Verworfen. Sieben Tage lang wird es nicht erneut vorgeschlagen.',
  'send': 'schreiben', 'call': 'anrufen', 'meet': 'treffen',
  'research': 'recherchieren', 'introduce': 'vorstellen lassen', 'wait': 'abwarten',

  'every signal cites what it was read from': 'jedes Signal nennt, woraus es gelesen wurde',
  'Signals →': 'Signale →',
  'No monitor exists and nothing has been raised. A monitor is a target with a cadence; its runs raise signals here, each citing a snapshot or a publication verbatim, with a suggested action waiting to be held.':
    'Es gibt keinen Monitor und es wurde nichts gemeldet. Ein Monitor ist ein Ziel mit einer Taktung; seine Läufe melden hier Signale, jedes mit wörtlichem Beleg aus Snapshot oder Publikation und einer vorgeschlagenen Handlung, die auf Übernahme wartet.',
  'The monitors ran and raised nothing new. That is a counted zero, not an absence of watching.':
    'Die Monitore liefen und meldeten nichts Neues. Das ist eine gezählte Null, kein fehlendes Beobachten.',
  'risk': 'Risiko', 'budget': 'Budget', 'board': 'Gremium', 'move': 'Wechsel',
  'post': 'Beitrag', 'tender': 'Ausschreibung', 'mention': 'Erwähnung', 'coverage': 'Abdeckung',
  'info': 'Info', 'attend': 'beachten', 'high': 'hoch',


  'Date not confirmed': 'Datum nicht bestätigt',
  'Kind': 'Art',
  'Date': 'Datum',
  'Title': 'Titel',
  'What happened, in a few words': 'Was geschah, in wenigen Worten',
  'Summary': 'Zusammenfassung',
  'Organisation': 'Organisation',
  'Search organisations': 'Organisationen suchen',
  'Participants': 'Teilnehmende',
  'Search people, or type a name and add it': 'Personen suchen oder einen Namen eingeben und hinzufügen',
  'Add "{name}" as a name, not yet a person': '„{name}“ als Namen hinzufügen, noch keine Person',
  'Touchpoint logged.': 'Kontakt erfasst.',
  'Could not save the touchpoint.': 'Kontakt konnte nicht gespeichert werden.',
  'Nothing logged here yet. A meeting, a call, a mail, a note — every touchpoint with provenance becomes a row.':
    'Hier ist noch nichts erfasst. Ein Treffen, ein Anruf, eine Mail, eine Notiz — jeder Kontakt mit Herkunftsnachweis wird zu einer Zeile.',
  'Mail in': 'E-Mail ein', 'Mail out': 'E-Mail aus', 'Meeting': 'Treffen', 'Call': 'Anruf',
  'Note': 'Notiz', 'Post': 'Beitrag', 'Signal': 'Signal',

  // ── overnight · the runs of the last day (R3f) ──
  'The runtime has not reported. Nothing is claimed about the night either way.': 'Die Laufzeit hat nichts gemeldet. Über die Nacht wird so oder so nichts behauptet.',
  'No run in the last day. The inside agents triage mail, draft replies and read pages overnight; each one appears here with its ref, and the ref opens the desk that shows what it did.': 'Kein Lauf im letzten Tag. Die inneren Agenten sichten nachts Post, entwerfen Antworten und lesen Seiten; jeder erscheint hier mit seiner Referenz, und die Referenz öffnet den Arbeitsplatz, der zeigt, was er getan hat.',
  'Open this run’s desk': 'Den Arbeitsplatz dieses Laufs öffnen',
  'filed': 'eingereicht',
}, 'TodayPage');
